<template>
    <div class="home-warp" :style="{'height':''+windowWidth+'px'}">
        <div class="banner" :style="{'background':''+bannerColor+''}">
            <div class="in" :style=[style]></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            banner:this.$parent.$parent.company.config.styleImages,
            windowWidth:'',
            bannerColor:'#1c2335',
            style:'',
            beliel:1,//宽高比
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getBeliel();
        }) 
    },
    created() {
		
    },
    methods: {
        //获取图片比列
        getBeliel () {
            let that = this;
            let windowWidth = document.body.clientHeight - 69 -59;
            that.windowWidth = windowWidth;
            let beliel = windowWidth/799;
            that.beliel = beliel;
            that.style={background:'url('+that.banner.banner+') no-repeat center center',backgroundSize:'auto 100%'}
            window.onresize = function() {
                windowWidth = document.body.clientHeight - 69 -59;
                that.windowWidth = windowWidth;
                beliel = windowWidth/799;
                that.beliel = beliel;
                that.style={background:'url('+that.banner.banner+') no-repeat center center',backgroundSize:'auto 100%'} 
            }
        } 
	}
}
</script>



// WEBPACK FOOTER //
// src/page/index/home1.vue